{
  "newTitle": "Nouvelle leçon",
  "editTitle": "Modifier la leçon",
  "uploadingTitle": "Téléversement de la vidéo",
  "uploadedTitle": "Vidéo téléversée",
  "saveLabel": "Enregistrer la leçon",
  "savingLabel": "Enregistrement",
  "titleLabel": "Titre",
  "titlePlaceholder": "Titre de la leçon",
  "descriptionLabel": "Description",
  "descriptionPlaceholder": "Un résumé de cette leçon en une ligne",
  "videoLabel": "Vidéo",
  "textLabel": "Texte",
  "fallbackFileName": "Vidéo",
  "previewFailed": "Impossible d'obtenir une URL de lecture pour cette vidéo.",
  "uploadStartFailed": "Le téléversement de la vidéo n'a pas pu démarrer.",
  "uploadFailed": "Le téléversement de la vidéo a échoué.",
  "thumbnailTargetFailed": "Impossible de préparer le téléversement de la miniature.",
  "thumbnailUploadFailed": "Le téléversement de la miniature a échoué. Veuillez réessayer.",
  "saveFailed": "Impossible d'enregistrer cette leçon pour le moment.",
  "uploadSavedCaption": "La leçon a été enregistrée. Vous pouvez relancer le téléversement, ou fermer et ajouter la vidéo plus tard.",
  "retryUpload": "Relancer le téléversement",
  "close": "Fermer",
  "uploadComplete": "Téléversement terminé. La vidéo sera disponible une fois le traitement terminé",
  "uploading": "Téléversement… {{percent}} %",
  "keepCurrentVideo": "Conserver la vidéo actuelle",
  "keepCurrentImage": "Conserver l'image actuelle",
  "clear": "Effacer",
  "uploadsAfterCreate": "Téléversée une fois la leçon créée.",
  "preparingPreview": "Préparation de l'aperçu…",
  "previewVideo": "Aperçu de la vidéo",
  "noVideo": "Aucune vidéo dans cette leçon.",
  "thumbnailTitle": "Miniature",
  "thumbnailCaption": "Affichée dans la liste des leçons avant la lecture de la vidéo.",
  "videoProcessing": "En traitement",
  "videoUploaded": "Téléversée",
  "videoHosted": "Hébergée",
  "videoUploadFailed": "Échec du téléversement",
  "videoProcessingDetail": "Vidéo en cours de traitement.",
  "editor": {
    "contentArea": {
      "editableMarkdown": "markdown modifiable"
    },
    "toolbar": {
      "undo": "Annuler {{shortcut}}",
      "redo": "Rétablir {{shortcut}}",
      "bold": "Gras",
      "removeBold": "Retirer le gras",
      "italic": "Italique",
      "removeItalic": "Retirer l'italique",
      "blockTypeSelect": {
        "placeholder": "Type de bloc",
        "selectBlockTypeTooltip": "Choisir le type de bloc"
      },
      "blockTypes": {
        "paragraph": "Paragraphe",
        "heading": "Titre {{level}}",
        "quote": "Citation"
      },
      "bulletedList": "Liste à puces",
      "numberedList": "Liste numérotée",
      "link": "Créer un lien",
      "table": "Insérer un tableau",
      "toggleGroup": "groupe de boutons"
    },
    "createLink": {
      "url": "URL",
      "urlPlaceholder": "Choisir ou coller une URL",
      "text": "Texte du lien",
      "textTooltip": "Le texte affiché pour le lien",
      "title": "Titre du lien",
      "titleTooltip": "L'attribut title du lien, affiché au survol",
      "saveTooltip": "Définir l'URL",
      "cancelTooltip": "Annuler la modification"
    },
    "linkPreview": {
      "edit": "Modifier l'URL du lien",
      "copyToClipboard": "Copier dans le presse-papiers",
      "copied": "Copié !",
      "remove": "Retirer le lien"
    },
    "dialogControls": {
      "save": "Enregistrer",
      "cancel": "Annuler"
    },
    "table": {
      "columnMenu": "Menu de la colonne",
      "rowMenu": "Menu de la ligne",
      "textAlignment": "Alignement du texte",
      "alignLeft": "Aligner à gauche",
      "alignCenter": "Centrer",
      "alignRight": "Aligner à droite",
      "insertColumnLeft": "Insérer une colonne à gauche de celle-ci",
      "insertColumnRight": "Insérer une colonne à droite de celle-ci",
      "deleteColumn": "Supprimer cette colonne",
      "insertRowAbove": "Insérer une ligne au-dessus de celle-ci",
      "insertRowBelow": "Insérer une ligne au-dessous de celle-ci",
      "deleteRow": "Supprimer cette ligne",
      "deleteTable": "Supprimer le tableau"
    }
  }
}
